import type { ReactNode } from 'react';
import * as reactDeviceDetect from 'react-device-detect';

interface DeviceProps {
  children: (props: typeof reactDeviceDetect) => ReactNode;
}

export default function Device({ children }: DeviceProps) {
  return children(reactDeviceDetect);
}
